import axios from 'axios' 
import { env, sortArray } from '../../tools'
import { RouteGeometryLegs } from '../models'
import { Place } from '../models/Place'
import { RouteSettings } from '../models/RouteSettings'

interface OSRMRequest {
  vehicle: 'truck' | 'car';
  method: 'route' | 'trip';
  full: boolean;
  custom: boolean;
  roundtrip: boolean;
}

interface OSRMRoute {
  distance: number;
  duration: number;
  geometry: {
    type: 'LineString';
    coordinates: Array<[number, number]>;
  };
  legs: Array<{
    distance: number;
    duration: number;
    summary: string;
    weight: number;
    steps: [];
  }>;
}

interface OSRMData {
  status: 200 | 400;
  code: 'Ok' | 'InvalidUrl' | 'InvalidService' | 'InvalidVersion' | 'InvalidOptions' | 'InvalidQuery' | 'InvalidValue' | 'NoSegment' | 'TooBig';
  trips: Array<OSRMRoute>;
  routes: Array<OSRMRoute>;
  waypoints: Array<{
    distance: number;
    hint: string;
    location: [number, number];
    name: string;
    trips_index?: number; 
    waypoint_index?: number; // only exists on optimized routes
  }>;
}

interface OSRMResponse {
  status: 200 | 400;
  data: OSRMData;
}

const osrmUrl = env('HOST_PHP') + '/getRoute.php'

export const fetchOSRMRoute = async (places: Place[], routeSettings: RouteSettings, detailed?: boolean) => {  
  const coords = places.map(place => place.coords.lon + ',' + place.coords.lat).join(';')
  const params = {
    coords: coords,
    vehicle: routeSettings.vehicle,
    full: detailed || routeSettings.detailed || false,
    custom: routeSettings.custom,
    roundtrip: routeSettings.type === 'AA',
  }
  const response: OSRMResponse = await axios.get(osrmUrl, { params: params })  
  
  if (!response.data.code) {
    throw new Error('Route server (' + routeSettings.vehicle + ') not responding.')
  }

  return response.data
}

export const getGeometryLegs = (data: OSRMData): RouteGeometryLegs => {
  const coordinates = (data.trips || data.routes)[0].geometry.coordinates
  const locations = sortArray<OSRMData['waypoints'][0]>(data.waypoints, 'waypoint_index').map(wp => wp.location)
  const legs: RouteGeometryLegs = []
  let i = 0
  coordinates.forEach(coords => {
    if (!legs[i]) legs[i] = []
    legs[i].push(coords)    
    if (i < locations.length && coords[0] == locations[i][0] && coords[1] == locations[i][1]) {      
      i++
    }
  })  
  return legs
}